export enum KeyboardKey {
    Escape = `Escape`,
    ArrowUp = `ArrowUp`,
    ArrowDown = `ArrowDown`,
    Tab = `Tab`,
}
